/**
 * @deprecated
 */
import $ from 'jquery';

//shimované pluginy většinou nemají export, většinou extendují jQuery object
require('fg-frontend/ramjet/partialUpdate');
require('./web/highslide-settings');
require('bootstrap/collapse');

require('./web/jquery.rowHeight');
require('./web/jquery.rwdBackground');
require('./web/jquery.unveil');
//require('./web/jquery.scrollSpeed');
require('./web/jquery.gm');
require('./web/jquery.webslider');
// require('./web/jquery.webslider.client');
require('./web/jquery.socialNetworkFetcher');
require('./web/jquery-ui.min');
require('./web/landingDevice');
// require('./web/referencesPopup');
require('./third/plUpload/fg.upload');
require('picturefill');
require('selectize');
var isMobile = require('./web/isMobile');
var PageLoader = require('./web/pageloader');


//export to window
web.googlemaps = window.web.googlemaps || {};
window.PageLoader = PageLoader;					// used in nonHP carousel


var $b = $('body');
var $w = $(window);

/* menu pro mobilní zařízení */
var controlMenu = function() {
	var visitedMenu = false;

	var init = function() {
		$b.on('click', '.js_menuBurger', function(e) {
			$(this).toggleClass('close');
			toggleMenu();
			e.preventDefault();
		});
	}

	var cloneMenu = function() {
		$('#page-header').before('<div class="help-menu" id="help-menu"></div>');
		$('.navigation').clone().appendTo('.help-menu');
		var heightNavigationList = $('#help-menu .navigation-list').height();

		$('#help-menu .navigation').removeClass().addClass('navigation');
		$('#help-menu .menu-burger').addClass('close');
		$('#help-menu .main-menu').attr('id', 'main-menu').addClass('in').addClass('main-menu-open');

		if ((window.innerHeight - 40) >= (heightNavigationList + 40)) {
			$('#help-menu .main-menu').css('height', (window.innerHeight - 40)+'px');
		} else {
			$('#help-menu .main-menu').css('height', (heightNavigationList + 40)+'px');
		}
		$('#help-menu').animate({
			height: window.innerHeight
		}, 1000, 'easeInOutCubic', function() {
		//}, 1000, function() {
			$('#help-menu').css('min-height', (heightNavigationList + 80)+'px');
		});
	};

	var destroyMenu = function() {
		$('.help-menu').remove();
	};

	var toggleMenu = function() {
		if (visitedMenu == false) {
			cloneMenu();
			visitedMenu = true;
		} else {
			$('#help-menu').css('min-height', 0);
			$('.help-menu').animate({
				height: 0
			}, 1000, 'easeInOutCubic', function() {
			//}, 1000, function() {
				destroyMenu();
				visitedMenu = false;
			});
		}
	};

	init();
}


/* nastavení výšky obsahu ve fotogalerie */
function setGalleryTeamHeight() {
	$('.photogallery').each(function(){
		var $t = $(this);

		$('.team, .year', $t).each(function(){
			$(this).height(($(this).width()-1));
		});
	});
};


/* styled file input */
$(document).on('change', '.button-file :file', function() {
	var input = $(this),
	numFiles = input.get(0).files ? input.get(0).files.length : 1,
	label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
	input.trigger('fileselect', [input, numFiles, label]);
});
$(document).on('fileselect', function(event, input, numFiles, label) {
	var log = numFiles > 1 ? numFiles + ' files selected' : label;
	if(input.length) {
		input.parents('.form-group').find('.file-label').html(log);
	}
});

$(document).on('click', '.plupload label', function(e) {
	e.preventDefault();
});


/* nastavení výšky elementu s motivovým obrázkem */
function setMatrixHeight() {
	$('.content-matrix').each(function(){
		var $t = $(this);

		if (window.innerWidth >= 1052) {
			$('.image', $t).height($t.height());
		} else {
			$('.image', $t).css('height', 'auto');
		}
	});
}

window.setMatrixHeight = setMatrixHeight;


/* nastavení roztačení google mapy v pobočkách */
function branchGoogleMap() {
	$('.js_google-map-pobocka').each(function(){
		var $t = $(this);
		var bodyWidth = $b.width();
		var containerWidth = $t.parents('.container').width();
		var gmOffset = Math.floor(((bodyWidth - containerWidth) / 2) - 20);

		if ((window.innerWidth >= 481) && (window.innerWidth <= 1052)) {
			$t.css('margin-left', -gmOffset+'px').css('margin-right', -gmOffset+'px');
		} else if (window.innerWidth >= 1053) {
			$t.css('margin-left', -gmOffset+'px').css('margin-right', 0);
		} else {
			$t.css('margin-left', 0).css('margin-right', 0);
		}
	});
}
window.branchGoogleMap = branchGoogleMap;

/* initialization lazy loading */
var lazyLoading = function() {
  // var $lazyLoadingElements = $('.photogallery .image, .list-case-study .image, .lazyloading');
  var $lazyLoadingElements = $('.lazyloading');
	$lazyLoadingElements.unveil(0);

	//scroll pro nacitani lazyloadingu
	if ($lazyLoadingElements.length > 0) {
		var topOffset = $w.scrollTop();
		$w.scrollTop(topOffset+1); $w.scrollTop(topOffset);
	}
};
window.lazyLoading = lazyLoading;


/* google map */
$.googlemap.setDefaults({
	mapOptions: {
		scrollwheel: false,
		styles: [ { "featureType": "landscape", "stylers": [ { "visibility": "off" } ] },{ "featureType": "poi", "stylers": [ { "visibility": "off" } ] },{ "featureType": "administrative.province", "stylers": [ { "visibility": "off" } ] },{ "featureType": "administrative.land_parcel", "stylers": [ { "visibility": "off" } ] },{ "featureType": "administrative.neighborhood", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.local", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.arterial", "stylers": [ { "visibility": "simplified" } ] },{ "featureType": "water", "stylers": [ { "visibility": "on" }, { "hue": "#00ccff" }, { "saturation": -83 }, { "lightness": -15 } ] },{ "featureType": "road", "elementType": "labels", "stylers": [ { "visibility": "off" } ] },{ "featureType": "transit", "stylers": [ { "visibility": "off" } ] },{ "featureType": "administrative.locality", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off" } ] },{ "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "lightness": 100 }, { "weight": 2.9 } ] },{ "featureType": "road.local", "stylers": [ { "visibility": "on" } ] },{ "featureType": "administrative.locality" } ]
	},
	markerTypes: [
		{},
		{
			icon: {
				url: '/img/google-map/marker-01.png',
				size: new google.maps.Size(48, 64),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(24, 64)
			},
			shape: {
				coords: [0, 0, 48, 64],
				type: 'rect'
			}
		}, {
			icon: {
				url: '/img/google-map/marker-02.png',
				size: new google.maps.Size(48, 64),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(24, 64)
			},
			shape: {
				coords: [0, 0, 48, 64],
				type: 'rect'
			}
		}
	],
	bubbleContentFormatter: function(mData) {
		var str = '';
		if (mData.title) { str = ''; }
		if (mData.bubbleContent) { str += mData.bubbleContent; }
		return str;

	}
});


/* přepínání co o nás řekli klienti na HP */
var carouselClientsSay = function(selector, item) {
	var $selector = $('.'+selector);
	var $item = $('.'+item ,$t)
	var $t;
	var countSlides;
	var animateTime = 800;
	var actualSlide = 0;
	var slideTimer = null;

	var init = function() {
		if ($('.'+selector).length) {
			set();
		}
		$('.control-item', $selector).on('click', function(e) {
			click($(this), e);
		});
	};

	var set = function() {
		$selector.each(function() {
			var control;
			$t = $(this);
			countSlides = $item.length;

			control = '<div class="control">\n';
			for (var i = 1; i <=countSlides; i++) {
				control += (i == 1) ? '\t<a class="control-item active" href="#">' + i + '</a>\n' : '\t<a class="control-item" href="#">' + i + '</a>\n';
			}
			control += '</div>\n';
			$selector.append(control);
		});

		//changeSlide();
	};

	var animateSlide = function(index) {
		var self = this;
		$('.control-item', $selector).removeClass('active');
		$item.eq(actualSlide).fadeToggle(animateTime, 'linear', function(){
			actualSlide++;
			actualSlide = (actualSlide == countSlides) ? 0 : actualSlide;
			if (index >= 0) {
				actualSlide = index;
			}
			$('.control-item', $selector).eq(actualSlide).addClass('active');
			$item.eq(actualSlide).fadeToggle(animateTime, 'linear');
			$('.homepage .list-boxies').rowHeight("setRowHeight");
			changeSlide();
		});
	};

	var changeSlide = function() {
		var self = this;

		clearTimeout(slideTimer);
		slideTimer = setTimeout(function() {
			animateSlide();
		}, 10000);
	};

	var click = function(obj, e) {
		e.preventDefault();
		var index = obj.index();
		clearTimeout(slideTimer);
		animateSlide(index);
	};

	init();
}

/* Dynamicky donačtený obsah s postupným dojezem na stránku */
var dynamicLoadedContent = function() {

	var init = function() {
		checkElementInViewportAndSetClass(0);
		$w.on('scroll', function() {
			checkElementInViewportAndSetClass(200);
		});
	};

	var isElementInViewport = function(el) {
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while(el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
			top < (window.pageYOffset + (window.innerHeight * 0.8)) &&
				left < (window.pageXOffset + window.innerWidth) &&
				(top + height) > window.pageYOffset &&
				(left + width) > window.pageXOffset
			);
	}

	var checkElementInViewportAndSetClass = function(time) {
		var addClassWhenIsInUserViewElements = document.querySelectorAll('.js_addClassWhenIsInUserView');
		for(var i = 0; i < addClassWhenIsInUserViewElements.length; i++){
			if (isElementInViewport(addClassWhenIsInUserViewElements[i]) === true) {
				window.setTimeout((i) => {
					addClassWhenIsInUserViewElements[i].classList.add('show-and-move-up');
				}, time,i);
			}
		}
	}

	init();
}


/*
	inicializace funkcí
==================================================*/
$w.on('load', function() {
	$('.list-cards, .boxies, .set-row-height, .list-case-study, .list-description, .homepage .list-boxies').rowHeight({
		selector: '.item'
	});
	$('.nasi-klienti .list-boxies, .nasi-klienti-projects').rowHeight({
		selector: '.wrapper'
	});
	carouselClientsSay('js_carouselClientsSay', 'blockquote-wrapper');
	//carousel();

	if ($('.js_carouselSlideInfoboxTitle').length) {
		var $t = $('.js_carouselSlideInfoboxTitle');

		$t.each(function () {
			if ($(this).height() > 180) {
				$(this).addClass('carousel__infobox-title--smaller');
			}
		})
	}

	if ($('.js_slideInfoboxTitle').length) {
		var $t = $('.js_slideInfoboxTitle');

		$t.each(function () {
			if ($(this).height() > 180) {
				$(this).addClass('slide__infobox__title--smaller');
			}
		})
	}

	if ($('.js_slideInfobox').length) {
		var $t = $('.js_slideInfobox');

		$t.each(function () {
			$(this).addClass('slide__infobox--js');
		})
	}

	if ($('.js_benefitsList').length) {
		benefitsListContent();
	}

	if ($('.landingpage-webs').length) {
		stickyButton();
	}

	if($('.js_scrollToAnchor').length) {
		var hashId = window.location.hash.substr(1);
		if(hashId !== '') {
			scrollToElement(hashId);
		}
	}

});

function scrollToElement(elementId)  {
	var element = document.getElementById(elementId);
	if(element != null){
		var elementOffsetTop = element.getBoundingClientRect().top + window.pageYOffset;
		window.scroll({
			top: elementOffsetTop, // could be negative value
			left: 0,
			behavior: 'smooth'
		});
	}
}

$w.on('resize', function() {
	setGalleryTeamHeight();
	setMatrixHeight();
	branchGoogleMap();
	//carousel();
});

$w.on('beforeunload', function() {
	$('body').removeClass('animated-body-show');
	window.setTimeout(function(){
		$('body').addClass('animated-body-show');
	}, 3000);
});

$('.bg-rwd').rwdBackground();
controlMenu();
setGalleryTeamHeight();
setMatrixHeight();
branchGoogleMap();
lazyLoading();
dynamicLoadedContent();

$(document).bind('afterContentsReplaced', function() {
  if (!isMobile.phone && !isMobile.tablet) {
    $('.form select').selectize();
  }
});
if (!isMobile.phone && !isMobile.tablet) {
  $('.form select').selectize();
}

$('body').on('validationFailed', 'form', function() {
	if($('.has-error', this).size() > 0) {
		var errorTopOffset = $('.has-error:first', this).offset().top;
		$('html, body').animate({ scrollTop: errorTopOffset });
	}
});

/* s novou verzi generatoru bude mozne nahradit timto blok vyse */
/*$('body').on('validationFailed', 'form', function() {
	var errorTopOffset = $('.has-error:first', this).offset().top;
	$('html, body').animate({ scrollTop: errorTopOffset });
});*/

if ($('.subListCareer .item').size() > 0) {
	$('.subListCareer .item').each(function () {
		if ($(this).children().size() > 2) {
			$(this).addClass('item--active');
		}
	});
}

$('.subListCareer').on('click', '.item--active', function() {
	// $(this).removeClass('item');
	$(this).toggleClass('rotate-icon');
	$('p',this).toggle();
	$('h3 + p',this).show();
});

//jQuery.scrollSpeed(300, 900);



var benefitsListContent = function () {
	var $block = $('.js_benefitsList');
	var $element = $('.modalBenefits');
	var countElements = $block.children().size();
	var currentBenefit = 0;

	var init = function () {
		$('body').append('<div class="modalBenefits"><div class="modalBenefits_wrapper"></div><a class="modalBenefits_close js_modalBenefitsClose" href="javascript:"></a></div>')

		if(countElements > 1) {
			$('.modalBenefits').prepend('<a class="modalBenefits_arrow modalBenefits_arrow-previous js_modalBenefitsArrow" href="javascript:" data-direction="-1"></a><a class="modalBenefits_arrow modalBenefits_arrow-next js_modalBenefitsArrow" href="javascript:" data-direction="1"></a>');
		}

		document.onkeydown = checkKey;

		$('.benefitsList_link', $block).on('click', function () {
			currentBenefit = $(this).parent().index()
			showBenefitsDetail($(this));
		});
		$('.js_modalBenefitsClose').on('click', function () {
			closeBenefitsDertail();
		});
		$('.js_modalBenefitsArrow.modalBenefits_arrow-previous').on('click', function() {
			changeBenefit('-1');
		});
		$('.js_modalBenefitsArrow.modalBenefits_arrow-next').on('click', function() {
			changeBenefit('+1');
		});
	}

	var checkKey = function (e) {
		e = e || window.event;

		if ($('.modalBenefits').is(":visible")) {
			if (e.keyCode == '27') {
				// escape
				closeBenefitsDertail();
			}
			else if (e.keyCode == '37') {
				// left arrow
				changeBenefit('-1');
			}
			else if (e.keyCode == '39') {
				// right arrow
				changeBenefit('+1');
			}
		}
	}

	var showBenefitsDetail = function ($element) {
		$('.modalBenefits_wrapper').html('<div class="modalBenefits_content">'+$element.html()+'</div>');
		$('.modalBenefits .benefitsList_body').removeClass('sr-only');
		$('.modalBenefits').show().css('top', ($(window).scrollTop() + ($(window).height() - $('.modalBenefits').height()) / 2)+'px');
	};

	var closeBenefitsDertail = function () {
		$('.modalBenefits').hide();
		$('.modalBenefits_wrapper').html('');
	};

	var changeBenefit = function(direction) {
		var newBenefit = currentBenefit;

		if (direction === '+1') {
			newBenefit++;
			newBenefit = (newBenefit == countElements) ? 0 : newBenefit;
		}

		if (direction === '-1') {
			newBenefit--;
			newBenefit = (newBenefit == -1) ? (countElements - 1) : newBenefit;
		}

		$('.modalBenefits_wrapper').html('');
		$('.modalBenefits_wrapper').html('<div class="modalBenefits_content">'+$('.benefitsList_link:eq('+newBenefit+')', $block).html()+'</div>');
		$('.modalBenefits .benefitsList_body').removeClass('sr-only');
		$('.modalBenefits').show().css('top', ($(window).scrollTop() + ($(window).height() - $('.modalBenefits').height()) / 2)+'px');

		currentBenefit = newBenefit;
	};

	init();
};

var stickyButton = function () {
	var $el = $('.js_stickyButton');
	var time = 200;

	var init = function () {
		var stopSticky = ($('.js_stickyButton').offset().top + $('.js_stickyButton').outerHeight()) - $w.height();

		onScroll(stopSticky);

		$w.on('scroll', function() {
			onScroll(stopSticky);
		});
		$w.on('resize', function() {
			onResize();
		});
	}

	var onScroll = function(stopSticky) {
		window.setTimeout(function(){
			var topOffset = $w.scrollTop();

			if (topOffset > stopSticky) {
				$el.removeClass('content__sticky');
			} else {
				$el.addClass('content__sticky');
			}
		}, time);
	}

	var onResize = function() {
		window.setTimeout(function(){
			$el.removeClass('content__sticky');
			init();
		}, time);
	}

	init();
};


/*
$('.list-case-study .image').unveil(0, function() {
	$(this).load(function() {
		$('.list-case-study').rowHeight({
			selector: '.item'
		});
	});
});
*/

// rovnani boxu v hlavicce detailu reference
/*
$('.list-blocks').rowHeight({
	selector: '.item'
});
*/




/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js